module.exports = __webpack_public_path__ + "media/images/restaurant/logo_savor_zh-292f74c50db7eabdceea1f77d3d296f6.png";